import type { TrackingEvent, TrackingPayload } from '../types'

const useOdoscopeEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => any,
) => ({
  trackOdoscopeError: (odoscopeToken: string) =>
    track(`odoscope/error/${odoscopeToken}`, {
      eventCategory: 'odoscope',
      eventAction: 'error',
      eventLabel: odoscopeToken,
    }),
  trackOdoscopeTimeout: (odoscopeToken: string) =>
    track(`odoscope/timeout/${odoscopeToken}`, {
      eventCategory: 'odoscope',
      eventAction: 'timeout',
      eventLabel: odoscopeToken,
    }),
  trackOdoscopeEmptyResponse: (responseOscTracking: string) =>
    track(`odoscope/empty/${responseOscTracking}`, {
      eventCategory: 'odoscope',
      eventAction: 'empty',
      eventLabel: responseOscTracking,
    }),
  trackOdoscopeControlGroup: (responseOscTracking: string) =>
    track(`odoscope/control/${responseOscTracking}`, {
      eventCategory: 'odoscope',
      eventAction: 'odoscope',
      eventLabel: responseOscTracking,
    }),
  trackOdoscopeSuccess: (responseOscTracking: string) =>
    track(`odoscope/odoscope/${responseOscTracking}`, {
      eventCategory: 'odoscope',
      eventAction: 'odoscope',
      eventLabel: responseOscTracking,
    }),
})

export default useOdoscopeEvents
